<template>
  <div ref="scrollContainer" id="page-panel" class="box grow" >
    <div class="customer-top-nav no-print">
      <div class="title">
        <span>{{$t('settings.cmsCarousel.title')}}</span>
      </div>
      <div class="controls">
				 <el-button type="primary" @click="openCarouselDialog" size="small"><i class="mdi mdi-plus-circle"><span style="padding-left:5px;">{{$t('common.New')}}</span></i> </el-button>
			</div>
    </div>
    <el-tabs type="border-card" v-if="showCarouselGroup" v-model="selectedGroupIndex" @tab-click="handlegroupChange">
      <el-tab-pane v-for="(carousels) in groupedCarousels" 
          :key="getCarouselName(carousels)"
          :label="getCarouselTitle(carousels)"
          :lazy="true" class="box grow scrollable" 
          :style="getHeightStyle"
          :name="getCarouselName(carousels)">
        <el-tabs tab-position="left" @tab-click="fetchContents" v-model="selectedCarouselIndex">
          <el-tab-pane 
            class="scrollable ml-20" 
            :style="height"
            :label="localeName(carousel)" v-for="carousel in carousels"
            :key="carousel.id"
            :name="carousel.id.toString()">
           
            <div class="sticky controls" style="height:40px;clear:both;text-align:right;width:100%;">
                <el-button @click="handleSave" type="primary" size="small" :disabled="stateUpdated == false">{{ $t('common.save') }}</el-button>
                <el-button @click="handleDelete(carousel)" size="small"  :disabled="selectedCarousel == null">{{ $t('common.Delete') }}</el-button>
                <el-button @click="handleCancel" size="small"  :disabled="stateUpdated == false">{{ $t('common.cancel') }}</el-button>
            </div>
            <el-form ref="test" :model="carouselModel" :rules="rules">
              <div>
                <el-descriptions :title="$t('carousel.groupTitle')" :border="true" class="mb-20 mt-60"  :column="1">
                  <el-descriptions-item :label="$t('carousel.groupCode')">
                    <el-form-item prop="group">
                      <el-input v-model="carouselModel.group" @keyup.native="stateUpdated = true"></el-input>
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('carousel.frenchGroupName')">
                    <el-form-item prop="groupNameFr">
                      <el-input v-model="carouselModel.groupNameFr" @keyup.native="stateUpdated = true"></el-input>
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('carousel.englishGroupName')">
                    <el-form-item prop="groupNameEn">
                      <el-input v-model="carouselModel.groupNameEn" @keyup.native="stateUpdated = true"></el-input>
                    </el-form-item>
                  </el-descriptions-item>
                </el-descriptions>
                <p class="bg-info-lighter p-10"><i class="el-icon-warning-outline"></i> {{ $t('carousel.groupWarning') }}</p>
                <el-descriptions :title="$t('carousel.configurationTitle')" :border="true" class="mb-20" :column="1">
                  <el-descriptions-item :label="$t('carousel.frenchName')">
                    <el-form-item prop="nameFr">
                      <el-input v-model="carouselModel.nameFr" @keyup.native="stateUpdated = true"></el-input>
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('carousel.englishName')">
                    <el-form-item prop="nameEn"> 
                      <el-input v-model="carouselModel.nameEn" @keyup.native="stateUpdated = true" ></el-input>
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('carousel.publicationState')"> 
                    <el-switch
                      @change="stateUpdated = true"
                      v-model="carouselModel.published"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('carousel.interval')">
                    <el-input-number v-model="carouselModel.interval" @keyup.native="stateUpdated = true" controls-position="right" @change="stateUpdated = true"></el-input-number>
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('carousel.randomMode')"> 
                    <el-switch
                      @change="stateUpdated = true"
                      v-model="carouselModel.random"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('carousel.type')"> {{ $t('carousel.types.'+carousel.type) }}</el-descriptions-item>
                </el-descriptions>
              </div>
            </el-form>
            <p class="bg-info-lighter p-10"><i class="el-icon-warning-outline"></i> {{ $t('carousel.productInventoryInstructions') }}</p>
            <el-autocomplete class="inline-input mb-10"  :trigger-on-focus="false" value-key="puid" v-model="contentSelected" style="width:100%;" :fetch-suggestions="querySearchProductInventory" :placeholder="$t('carousel.selectProductInventory')" @select="handleSelectContent">
              <template slot-scope="{ item }">
                <ItemTemplate :product="item" :showInventoryName="true" :quantity="item.quantity" :inventory="item.inventory" :format="item.format" :volume="item.volume"></ItemTemplate>
              </template>
            </el-autocomplete>
            <h4>{{ $t('carousel.contents') }}</h4>
            <el-skeleton  :loading="loadingContents" animated>
                <template slot="template">
                  <el-skeleton-item v-for="index in 10" :key="index" class="p-10" style="width: 100%;" />
                </template>
                <template >
                  <draggable  v-model="contents" handle=".handle" :move="onMove" v-bind="dragOptions" @start="drag = true" @end="drag = false" @change="orderChange">
                    <transition-group type="transition" :name="'flip-list'">
                      <div :loading="loadingContents" v-for="(content, index) in contents" :key="content.id" class="p-5 border m-5 " :class="{'bg-danger-lighter' : isProblmetic(index)}">
                        <el-row type="flex">
                          <el-col :span="18" class="m-5">
                            <i class="mdi mdi-drag handle" v-if="orderable"  @click=" element.fixed=! element.fixed" aria-hidden="true"></i>
                            <i class="mdi mdi-drag" v-else  aria-hidden="true"></i>
                            <span class="fs-12">{{ content.cmsName }} </span>
                            <span class="fs-12">{{ content.currentVintage }} </span>
                            <span class="fs-10">x{{content.uvc}} - {{ content.lblFormat }}</span>
                            <span class="ml-10 fs-10"> - {{ content.inventory.name }} </span>
                          </el-col>
                          <el-col :span="6" class="text-right align-vertical-middle">
                            <el-button
                              size="mini"
                              type="danger"
                              @click="removeContent(index)"
                              circle
                              ><i class="mdi mdi-delete fs-12" ></i></el-button>
                          </el-col>
                        </el-row>
                      </div>
                     
                    </transition-group>
                  </draggable>
                  <div v-if="contents.length === 0 && loadingContents== false">
                    <p class="bg-info-lighter p-10"><i class="el-icon-warning-outline"></i> Le carousel est vide, veuillez ajouter du contenu!</p>
                  </div>
                </template>
              </el-skeleton>
           
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
    <div v-else  class="card card-shadow--small bg-white flexContainer" style="text-align:center;">
      <div style="width:400px;height:400px" class="mt-60 mb-20">
        <el-carousel :interval="4000" type="card" height="200px">
          <el-carousel-item v-for="item in 6" :key="item">
            <h3 class="medium">{{ item }}</h3>
          </el-carousel-item>
        </el-carousel>
      <span class="pt-20">{{ $t('carousel.noCarouselInstruction') }}</span>
    </div>
    
    </div>
    <carouselDrawer :visible="carouselDialogVisible" @close="closeCarouselDialog" @add="handleAdd" :groups="groups"/>
  </div>
</template>
<script>

import cmsAPI from '@/services/API/cmsAPI';
import inventoryAPI from '@/services/API/inventory';
import ItemTemplate from '@/components/product/item-template-v2'
import draggable from 'vuedraggable';
import carouselDrawer from './components/carousel-drawer.vue';

export default {
  name: 'CMSCarousel',

  data() {
    return {
      carousels : [],
      window: {
        width: 0,
        height: 0
      },
      filter: {
        active: true,
      },
      selectedGroupIndex: null,
      selectedCarouselIndex: 0,
      contentSelected: null,
      stateUpdated: false,
      selectedCarousel: null,
      carouselModel : {
        id: null,
        nameFr : null,
        nameEn: null,
        group: null,
        groupNameFr: null,
        groupNameEn: null,
        interval: null,
        random: null,
        published: null,
      },
      contents: [],
      loading: true,
      loadingContents: false,
      drag : false,
      carouselDialogVisible: false,
      rules : {
        group : [
          { required: true, message: this.$i18n.t('carousel.groupMandatoryInstruction'), trigger: 'blur' }
        ],
        groupNameFr : [
          { required: true, message: this.$i18n.t('carousel.groupNameFrMandatoryInstruction'), trigger: 'blur' }
        ],
        groupNameEn : [
          { required: true, message: this.$i18n.t('carousel.groupNameEnMandatoryInstruction'), trigger: 'blur' }
        ],
        nameFr : [
          { required: true, message: this.$i18n.t('carousel.nameFrMandatoryInstruction'), trigger: 'blur' }
        ],
        nameEn : [
          { required: true, message: this.$i18n.t('carousel.nameEnMandatoryInstruction'), trigger: 'blur' }
        ]
      }
    };
  },components: {
    draggable,
    carouselDrawer,
    ItemTemplate,
  },
	methods: {
    handlegroupChange(tab) {
      this.selectFirstCarouselOfGroup(tab.name);
    },
    handleSelectContent(content) {
      this.contents.push(content);
      this.contentSelected = null;
      this.stateUpdated = true;
      this.$message.success('Le contenu a été ajouté avec succès. Veuillez sauvegarder vos dernières modifications.');
    },
    querySearchProductInventory(queryString, cb){
      return inventoryAPI.fetchProductsV2({  searchTerms: queryString, paging: 'no', limit:25})
          .then(products => {
            cb(products);
          });
    },
    validate(){
      // Validation custom car la validation du form ne foncitonne pas
      let valid = true;

      if (_.isEmpty(_.trim(this.carouselModel.group))) {
        valid = false;
      }

      if (_.isEmpty(_.trim(this.carouselModel.groupNameFr))) {
        valid = false;
      }
      if (_.isEmpty(_.trim(this.carouselModel.groupNameEn))) {
        valid = false;
      }

      if (_.isEmpty(_.trim(this.carouselModel.nameFr))) {
        valid = false;
      }

      if (_.isEmpty(_.trim(this.carouselModel.nameEn))) {
        valid = false;
      }
      if (valid) {
        return Promise.resolve(valid);
      }
      return Promise.reject(valid);
      
    },
    handleSave() {
      console.log(this.$refs['formCarousel-1'])
      
      return this.validate()
        .then(() => {
          //Sert seulement pour les mise à jour
          const putInfo = {
            interval: this.carouselModel.interval,
            group: this.carouselModel.group,
            groupNameFr: this.carouselModel.groupNameFr,
            groupNameEn: this.carouselModel.groupNameEn,
            published: this.carouselModel.published,
            random: this.carouselModel.random,
            configuration: {
              type: this.selectedCarousel.type,
              contents: _.map(this.contents, c => (c.puid)),
            },
            languages: [
              {
                id: 1,
                name: this.carouselModel.nameFr,
              },
              {
                id: 2,
                name: this.carouselModel.nameEn,
              }
            ]
          }
          cmsAPI.updateCarousel(this.selectedCarousel.id, putInfo)
            .then((carouselUpdated) => {

              this.fetchCarousels();
              this.$message.success(this.$i18n.t('carousel.updateSuccess'));
            })
            .catch((err) => {
              this.$message.success(this.$i18n.t('common.errors.generic'));
            })
        })
        .catch(() => {
          this.$message.warning(this.$i18n.t('common.formIncomplete'));
        })
      
    },
    handleAdd(){
      this.fetchCarousels();
    },
    openCarouselDialog(){
      this.carouselDialogVisible = true;
    },
    closeCarouselDialog () {
      this.carouselDialogVisible = false;
    },
    handleDelete(carousel){
      return cmsAPI.deleteCMSCarousel(carousel.id)
      .then(() => this.fetchCarousels());
    },
    localeName(carousel){
      const locale =  this.$i18n.locale;
      if (locale === 'fr') {
        return _.get(_.find(carousel.languages, l => l.id === 1), 'name');
      } else {
        return _.get(_.find(carousel.languages, l => l.id === 2), 'name');
      }
    },
    initCarouselModel () {
      this.fetchContents();
    },
    handleCancel(){
      this.initCarouselModel();
      this.stateUpdated = false;
    },
    removeContent(index) {
      this.stateUpdated = true;
      this.contents.splice(index, 1);
    },
    isProblmetic (index) {
      let problematic = false;
      const content = this.contents[index];
      if (content == null) problematic = true;
      
      if (_.get(this.selectedCarousel, 'type') === 'PRODUCT-INVENTORY') {
        // if (_.get(content, 'quantity.inStock') <= 0) {
        //   problematic = true;
        // }

        if (_.get(content, 'puidPublished') === false) {
          problematic = true;
        }
      }


      return problematic;
    },
    orderChange(){
      this.stateUpdated = true;
      // _.forEach(this.activeTags, (t, index)=>{t.order_ = index+1})
      // return SystemAPI.updateTags(this.activeTags)

    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    fetchProductInventory (puids){
      this.stateUpdated = false;
      this.loadingContents = true;
      if (!_.isEmpty(puids)) {
        return inventoryAPI.fetchProductsV2({ puid: puids, paging: 'no' })
        .then((productInventoy) => {
          this.contents = [];
          const groupedProductInventory = _.groupBy(productInventoy, 'puid');
          _.forEach(this.selectedCarousel.configuration.contents, c => {
            const myProductInventory = _.head(groupedProductInventory[c]);
            if (myProductInventory != null) {
              this.contents.push(myProductInventory);
            }
            
          })
          setTimeout(() => {
            this.loadingContents = false;
          }, 500);
          
        })
      } else {
        this.contents = [];
        this.loadingContents = false;
      }
      

    },
    fetchContents (tabName, carousel) {

      // on test le tabName, car on utilise cette fonction pour initialiser le model. Ainsi on peut 
      // réinitialiser le model sans passer le paramètre = init le model en cours.
      if (tabName != null) {
        this.selectedCarousel = _.find(this.carousels, c => c.id.toString() === tabName.name);
      } else if (carousel != null) {
        this.selectedCarousel = carousel;
      }
      this.carouselModel.nameFr = _.find(this.selectedCarousel.languages, l => l.id === 1).name;
      this.carouselModel.nameEn = _.find(this.selectedCarousel.languages, l => l.id === 2).name;
      this.carouselModel.interval = this.selectedCarousel.interval;
      this.carouselModel.random = this.selectedCarousel.random;
      this.carouselModel.published = this.selectedCarousel.published;
      this.carouselModel.groupNameFr = this.selectedCarousel.groupNameFr;
      this.carouselModel.groupNameEn = this.selectedCarousel.groupNameEn;
      this.carouselModel.group = this.selectedCarousel.group;
      if (_.get(this.selectedCarousel, 'configuration.type') === 'PRODUCT-INVENTORY') {
        return this.fetchProductInventory(_.get(this.selectedCarousel, 'configuration.contents'));
      } else {
        this.contents = [];
      }
    },
    selectFirstCarouselOfGroup(groupName){
      const carousels = this.groupedCarousels[groupName];
      const firstCarousel = _.head(carousels);
      this.selectedCarouselIndex = firstCarousel.id.toString();
      this.fetchContents(null, firstCarousel);
    },
    fetchCarousels(){
      this.loading = true;
      return cmsAPI.fetchCMSCarousels({})
        .then((carousels) => {
          this.loading = false;
          this.carousels = carousels;
          
          if (this.selectedGroupIndex == null || this.selectedGroupIndex == 0) {
            this.selectedGroupIndex = _.head(this.groups).group;
          }
          if (this.groupedCarousels[this.selectedGroupIndex] == null) {
            this.selectedGroupIndex = _.head(this.groups).group;
          }
          this.selectFirstCarouselOfGroup(this.selectedGroupIndex)
        })
        .catch((err) => {
          this.loading = false;
        })
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getCarouselName(c) {
      return _.get(_.head(c), 'group');
    },
    getCarouselTitle(c){
      const locale =  this.$i18n.locale;
       // On affiche le nom du groupe avec le nombre en parenthèse
       let groupName = '';
        if (locale === 'fr') {
          groupName =  _.get(_.head(c), 'groupNameFr');
        } else {
          groupName =  _.get(_.head(c), 'groupNameEn');
        }
        if (groupName == null || groupName === '') {
          return `${_.head(c).group} (${_.size(c)})`;
        } else {
          return `${groupName} (${_.size(c)})`;
        }
    },
	},
	computed: {
    showCarouselGroup () {
      return _.size(this.groupedCarousels) > 0;
    },
    orderable () {
      return this.carouselModel.random === false;
    },
    groups () {
      const groups = _.map(this.groupedCarousels, gc => ( { group : _.head(gc).group, groupNameFr: _.head(gc).groupNameFr, groupNameEn: _.head(gc).groupNameEn }));
      return _.uniqBy(groups, 'group');
    },
    height(){
        return "height :"+(this.window.height-270) + "px"
      },
    dragOptions() {
      return {
        animation: 200,
        group: "code",
        disabled: !this.orderable,
        ghostClass: "ghost"
      };
    },
    groupedCarousels(){
      return _.groupBy(this.carousels, 'group');
    },
    getHeight(){
      return (this.window.height-270);
    },
    getHeightStyle(){
      return "height:" + this.getHeight + "px;";
    },
	},
  mounted(){

  },
  created(){
    this.handleResize();
    this.fetchCarousels();
  },
  destroyed() {

  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.flexContainer {
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 20px 20px;
  // flex-direction: column;
}

.sticky {
  position: sticky !important;
  top: 0;
  padding: 10px 16px;
  background: #fff;
  color: #f1f1f1;
  z-index:1000;
}

.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:50px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}
.active{
  background-color: lighten($background-color, 20%);
  border-radius: 5px;
  box-shadow:none;
  box-shadow: 0 4px 8px 0 rgba(40,40,90,.09),0 1px 3px 0 rgba(0,0,0,.065);
}

.item-list {
  //margin: 0 auto;
  width: 100%;
  // padding: 0px 30px;
  box-sizing: border-box;

  .item {
    margin: 10px 0;
    padding: 5px;
    box-sizing: border-box;
    cursor: pointer;
    transition: all .5s .25s;


    .info {
      word-break: break-word;

    }

    &:hover {
      //margin: 15px -20px;
      //padding: 10px;
      background-color: lighten($background-color, 20%);
      border-radius: 5px;
      box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

    }

  }
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

.handle {
    cursor: move; /* fallback if grab cursor is unsupported */
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webkit-grab;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.handle:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
}

@media (max-width: 1024px) {

	#page-panel{
		padding:0px;
		margin:0px;
	}

	.customer-top-nav{
		height:60px;
		padding-top:10px;
		padding-left:10px;
		padding-right:10px;
	}

}

</style>
